import { useT } from "../i18n";
import {
  buildRadarChartSvgMarkup,
  type RadarChartScores,
} from "./RadarChartSvg";

interface ProgressiveRadarChartProps {
  completedThemes: number; // 1, 2, 3, or 4
  scores: RadarChartScores;
}

export function ProgressiveRadarChart({
  completedThemes,
  scores,
}: ProgressiveRadarChartProps) {
  const t = useT();
  const axisLabels = [
    t("groups.1"),
    t("groups.2"),
    t("groups.3"),
    t("groups.4"),
  ] as const;
  const svgMarkup = buildRadarChartSvgMarkup(
    scores,
    completedThemes,
    false,
    axisLabels,
    t("radar.svgTitle"),
    t("radar.svgDesc"),
  );

  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="relative" role="img" aria-label={t("radar.ariaLabel")}>
        <div
          className="w-full h-auto"
          // biome-ignore lint/security/noDangerouslySetInnerHtml: the SVG markup is generated from controlled numeric inputs and escaped labels.
          dangerouslySetInnerHTML={{ __html: svgMarkup }}
        />
      </div>

      <div className="flex justify-center gap-2 mt-6">
        {[1, 2, 3, 4].map((step) => (
          <div
            key={step}
            className="w-2 h-2 rounded-full"
            style={{
              backgroundColor:
                step <= completedThemes
                  ? "#00AFFD"
                  : "rgba(255, 255, 255, 0.3)",
            }}
          />
        ))}
      </div>

      <div className="text-center mt-2">
        <p className="text-white text-sm font-[Roboto] opacity-60">
          {t("radar.progress", { num: String(completedThemes) })}
        </p>
      </div>
    </div>
  );
}
